import { hasRole } from "@netmountains/shared/browser";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { landingRouteFor } from "./pages";

RequireRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
};

/**
 * Shows a page only to the roles that may open it (`pages.js`) and sends any other account to its
 * own landing page. Signed out, it shows nothing: `DashboardLayout` sends the visitor to the
 * login.
 */
export default function RequireRole({ roles, children }) {
  const account = useSelector(state => state.account);

  if (!account || Object.keys(account).length === 0) return null;
  if (!hasRole(account, roles)) return <Navigate to={landingRouteFor(account)} replace />;
  return children;
}
